import React, { useContext } from "react";
import "./index.scss";
import { UserContext } from "../context/userContext";
function ModalDisconnect({ closeModalDisconnect = () => {} }) {
  const { doLogout } = useContext(UserContext);
  return (
    <div className="disconnect-contaier">
      <div className="modal-cancel-header">
        <i
          className="bx bx-x"
          style={{ fontSize: 32 }}
          onClick={() => closeModalDisconnect()}
        ></i>
      </div>
      <div className="modal-cancel-body">
        Êtes-vous sûr de vouloir Déconnecter ?
      </div>
      <div className="modal-cancel-footer">
        <button
          className="btn-modal-cancel-cancel"
          onClick={() => closeModalDisconnect()}
        >
          Annuler
        </button>
        <button className="btn-modal-cancel-confirm" onClick={() => doLogout()}>
          Confirmer
        </button>
      </div>
    </div>
  );
}

export default ModalDisconnect;
